<style scoped lang="scss">
a {
  color: #fff !important;
}
.router-link-active, .router-link-active:hover {
  background-color: #fff !important;
  color: #000 !important;
}
</style>

<template>
  <nav class="navbar is-fixed-top is-black">
    <div class="navbar-brand">
      <strong class="navbar-item">
        ArtStory
      </strong>
    </div>

    <div
      id="navbarExampleTransparentExample"
      class="navbar-menu"
    >
      <div class="navbar-start" />

      <div class="navbar-end">
        <router-link
          class="navbar-item"
          to="/admin/stories"
        >
          STORIES
        </router-link>
        <router-link
          class="navbar-item"
          to="/admin/art"
        >
          ART
        </router-link>
        <router-link
          class="navbar-item"
          to="/admin/settings"
        >
          Settings
        </router-link>
        <router-link
          class="navbar-item"
          to="/admin/profile"
        >
          {{ user.username }}
        </router-link>
        <a
          class="navbar-item"
          @click="$store.commit('logout');"
        >
          Logout&nbsp;
          <i class="logout fas fa-sign-out-alt" />
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Header',
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      jwt: (state) => state.profile.jwt,
    }),
  },
};
</script>
